module.exports = __webpack_public_path__ + "img/shifted-logo-white.c81a7e8f.png";